import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyCI5paAJw583UjkLtIIuDQlaN3_yWfkitI',
  authDomain: 'authentech-a2299.firebaseapp.com',
  projectId: 'authentech-a2299',
  storageBucket: 'authentech-a2299.appspot.com',
  messagingSenderId: '160665611373',
  appId: '1:160665611373:web:39506543637ecd1c8aa364',
}

const app = initializeApp(firebaseConfig)
export default app
